import styled from 'styled-components'

export const Header = styled.div`
    display: flex;
    flex: 0 0 20px;
    background: ${props => props.theme.color.color3};
    z-index: 3;
`